import styles from './styles.scss';
import Button from 'components/Shared/Button';
import cn from 'classnames';

interface SliderDotsProps {
  goToSlide: () => void;
  isActiveSlide: () => boolean;
}

export const SliderDots = ({ isActiveSlide, goToSlide }: SliderDotsProps) => (
  <Button appearance="clear" onClick={goToSlide}>
    <div
      className={cn(styles.sliderButton, {
        [styles.active]: isActiveSlide()
      })}
    />
  </Button>
);
